import ProfilePage from "./ProfilePage";

const keyName = "ZmuProfilePage";
export default class ZmuProfilePage extends ProfilePage {
}


